// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module--header--BkcGW","subtitle":"index-module--subtitle--3iUGI"};